import { getElementTopOffset } from "./getElementTopOffset";

export const scrollToFirstErrorField = () => {
    const firstErrorField = document.querySelectorAll(".field.error")[0];

    const top = getElementTopOffset(firstErrorField);
    try {
        window.scrollTo({ top, behavior: "smooth" });
    } catch {
        // swallow scroll errors
    }
};
